import React from 'react'

const Resources = () => {
  return (
    <div>
      I am resources.
    </div>
  )
}

export default Resources
